<template>
    <div component="ScrollTableDetail">
        <slot></slot>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ContractDetail from '@/components/Profile/Contracts/ContractDetail.vue';
import ScrollTable from '@/components/.global/ScrollTable/ScrollTable.vue';

export default {
    name: 'ScrollTableDetail',

    data() {
        return {};
    },

    components: {
        ScrollTable,
        ContractDetail,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ScrollTableDetail'] {
    height: 100%;
}
</style>
